import React, { Children, useEffect } from 'react';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { u as useDataListLayoutContext } from './DataListLayoutContext-CRuQjlBl.js';
import { D as DataListItemActionsOverflow } from './DataListItemActionsOverflow-CcY2WaXQ.js';
import { G as Glimmer } from './Glimmer-C-gTChiy.js';

var styles = {"hidden":"_0m75bgCVBhk-"};

function DataListLayoutActions() {
    const { itemActionComponent, loadingState } = useDataListContext();
    const { setHasInLayoutActions } = useDataListLayoutContext();
    const { children: actionsChildren } = (itemActionComponent === null || itemActionComponent === void 0 ? void 0 : itemActionComponent.props) || {};
    const actions = Children.toArray(actionsChildren);
    const hasActions = actions.length > 0;
    useEffect(() => {
        setHasInLayoutActions(hasActions);
        return () => {
            setHasInLayoutActions(false);
        };
    }, []);
    if (loadingState === "initial") {
        return React.createElement(Glimmer, { shape: "square", size: "large" });
    }
    if (!hasActions)
        return null;
    return (React.createElement(DataListLayoutActionsWrapper, null,
        React.createElement(DataListItemActionsOverflow, { actions: actions })));
}
function DataListLayoutActionsWrapper({ children }) {
    const { isInLayoutProvider } = useDataListLayoutContext();
    if (isInLayoutProvider)
        return React.createElement(React.Fragment, null, children);
    return React.createElement("div", { className: styles.hidden }, children);
}

export { DataListLayoutActions as D };
